import { useMemo } from 'react'

import { useHierarchyPropertyOptionUsageQuery } from '~/client/graph/operations/generated/Resources.generated'

export interface HierarchyOptionUsage {
  usedOptionValues: Set<string>
  isLoading: boolean
  hasError: boolean
}

export const useHierarchyOptionUsage = (
  projectId?: string,
  propertyId?: string | null,
): HierarchyOptionUsage => {
  const skip = !projectId || !propertyId

  const { data, loading, error } = useHierarchyPropertyOptionUsageQuery({
    variables: { projectId: projectId ?? '', propertyId: propertyId ?? '' },
    skip,
    fetchPolicy: 'cache-and-network',
  })

  const usedOptionValues = useMemo(
    () => new Set<string>(data?.hierarchyPropertyOptionUsage ?? []),
    [data],
  )

  return {
    usedOptionValues,
    isLoading: !skip && loading && !data,
    hasError: !!error,
  }
}
